import { useContext } from 'react';
import { useStatuses } from '@namespace/account';
import { useAmplitude } from '@namespace/analytics';
import { useOtherSettings } from '@namespace/cms';
import { useDeviceStore } from '@namespace/device';
import { useI18n } from '@namespace/i18n';
import { UserContext } from '@namespace/user';

export const useAmplitudeInit = () => {
  const [user] = useContext(UserContext);
  const { amplitude = {} } = useOtherSettings();
  const { isMobile } = useDeviceStore();

  const { isNotVerified } = useStatuses();
  const { f } = useI18n();

  useAmplitude(user, amplitude, isNotVerified, f, isMobile);
};
